let singleQuotationMock = {
    'id': '374507473',
    'code': '3751677039',
    'premiumBase': '410.39265874347307579655913635',
    'premiumTariffBase': '294',
    'premiumCommercial': '294',
    'directcompensationpremium': '22',
    'premiumCollection': [
        {
            'chc': '0',
            'lineofbusinessclassid': '78',
            'lineofbusinessclassname': '',
            'insuredvalue': '6070000',
            'premium': '294'
        }
    ],
    'bonusMalus': 'B8',
    'instalmentno': '1',
    'averageExpeditureAmount': '35.87',
    'averageExpediturePercent': '12.2',
    'overlappingPolicy': 'false',
    'existingPolicyStartDate': '0001-01-01T00:00:00',
    'existingPolicyEndDate': '0001-01-01T00:00:00'
};

let quotationMock = {
    'sixMonthQuotation': {
        'id': '375017471',
        'code': '3756827028',
        'premiumBase': '469',
        'premiumTariffBase': '422',
        'premiumCommercial': '422',
        'directcompensationpremium': '44',
        'premiumCollection': [
            {
                'chc': '0',
                'lineofbusinessclassid': '78',
                'lineofbusinessclassname': '',
                'insuredvalue': '6070000',
                'premium': '422'
            }
        ],
        'bonusMalus': 'B0',
        'instalmentno': '1',
        'averageExpeditureAmount': '51.48',
        'averageExpediturePercent': '12.2',
        'overlappingPolicy': 'false',
        'existingPolicyStartDate': '0001-01-01T00:00:00',
        'existingPolicyEndDate': '0001-01-01T00:00:00'
    },
    'yearQuotation': {
        'id': '375017472',
        'code': '3756827014',
        'premiumBase': '824',
        'premiumTariffBase': '742',
        'premiumCommercial': '742',
        'directcompensationpremium': '88',
        'premiumCollection': [
            {
                'chc': '0',
                'lineofbusinessclassid': '78',
                'lineofbusinessclassname': '',
                'insuredvalue': '6070000',
                'premium': '742'
            }
        ],
        'bonusMalus': 'B0',
        'instalmentno': '1',
        'averageExpeditureAmount': '90.52',
        'averageExpediturePercent': '12.2',
        'overlappingPolicy': 'false',
        'existingPolicyStartDate': '0001-01-01T00:00:00',
        'existingPolicyEndDate': '0001-01-01T00:00:00'
    }
};

const moment = require('moment');
const state = require('./state.js');
const DOM = require('./dom.js');
const ui = require('../ui');
const vehicle = require('../vehicle');
const insured = require('../insured');
const details = require('../details');
const { useKeys } = require('../common.js');
const { AttachState } = require('../helpers.js');

export const init = async () => {
    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        let req = {
            vin: vehicle.state.vin,
            postalCode: insured.state.postalCode,
            county: insured.state.county,
            city: insured.state.cityCode,
            street: insured.state.street,
            startDate: insured.state.date.format('YYYY-MM-DD'),
            isRegistered: true,
            isLeasing: false,
            isTaxi: vehicle.state.isTaxi,
            vehicleClass: vehicle.state.class,
            vehicleBrand: vehicle.state.brand,
            vehicleType: vehicle.state.model,
            vehicleMaxWeight: vehicle.state.maxWeight,
            vehicleYear: vehicle.state.year,
            vehicleSeatNo: vehicle.state.seatNo,
            vehicleEnginePower: vehicle.state.enginePower,
            vehicleEngineDisplacement: vehicle.state.engineDisplacement,
            vehicleEnergySource: vehicle.state.energySource
        };
        if (insured.state.isCompany)
            req.cui = insured.state.cnp;
        else
            req.cnp = insured.state.cnp;

        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/quotation?requestId=${ui.state.flowId}`, {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // await new Promise(resolve => setTimeout(resolve, 1000));
        // let response = {
        //     ok: true,
        //     json: async () => (quotationMock)
        // };

        ui.state.isLoading = false;
        let quotations = await response.json();
        if (quotations.body && !response.ok) {
            let faultstring = quotations.body.match(new RegExp('(<faultstring.+">)(.+(?=</faultstring))', 'im'));
            if (faultstring && faultstring.length > 0) {
                faultstring = faultstring[faultstring.length - 1];

                ui.notyf.error(faultstring);
                ui.state.slide = [1, 2];
                return;
            }
        }

        if (!response.ok)
            throw new Error('bad request');

        if (quotations.sixMonthQuotation.overlappingPolicy === 'true') {
            ui.state.slide = [1, 2];
            ui.notyf.error(`Exista deja o poliță activă pâna la ${moment(quotations.sixMonthQuotation.existingPolicyEndDate).format('DD/MM/YYYY')}`);
            insured.txtDate.state.date = moment(quotations.sixMonthQuotation.existingPolicyEndDate).add(1, 'day');
            insured.txtDate.state.focused = true;
            return;
        }

        state.quotations[6] = quotations.sixMonthQuotation;
        state.quotations[12] = quotations.yearQuotation;
        state.quotations.custom = null;
        DOM.btnOffer12M.click();

        calc(state.validity, state.hasDD, state.installments);
        ui.state.slide = [2, 0];
    } catch (err) {
        ui.state.isLoading = false;
        ui.notyf.error('Ne pare rău, am întâmpinat o eroare');
        console.error(err);
        ui.state.slide = [1, 2];
    }
};

const fetchQuotation = async (validity) => {
    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        let req = {
            vin: vehicle.state.vin,
            postalCode: insured.state.postalCode,
            county: insured.state.county,
            city: insured.state.cityCode,
            street: insured.state.street,
            startDate: insured.state.date.format('YYYY-MM-DD'),
            isRegistered: true,
            isLeasing: false,
            isTaxi: vehicle.state.isTaxi,
            vehicleClass: vehicle.state.class,
            vehicleBrand: vehicle.state.brand,
            vehicleType: vehicle.state.model,
            vehicleMaxWeight: vehicle.state.maxWeight,
            vehicleYear: vehicle.state.year,
            vehicleSeatNo: vehicle.state.seatNo,
            vehicleEnginePower: vehicle.state.enginePower,
            vehicleEngineDisplacement: vehicle.state.engineDisplacement,
            vehicleEnergySource: vehicle.state.energySource,
            insuranceInstalmentNo: 1,
            insurancePeriodInMonths: validity
        };
        if (insured.state.isCompany)
            req.cui = insured.state.cnp;
        else
            req.cnp = insured.state.cnp;

        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/quotation/web?requestId=${ui.state.flowId}`, {
            method: 'POST',
            body: JSON.stringify(req),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // await new Promise(resolve => setTimeout(resolve, 1000));
        // let response = {
        //     ok: true,
        //     json: async () => (singleQuotationMock)
        // };

        ui.state.isLoading = false;
        let quotation = await response.json();

        if (quotation.body && !response.ok) {
            let faultstring = quotation.body.match(new RegExp('(<faultstring.+">)(.+(?=</faultstring))', 'im'));
            if (faultstring && faultstring.length > 0) {
                faultstring = faultstring[faultstring.length - 1];

                ui.notyf.error(faultstring);
                DOM.btnOffer12M.click();
                return;
            }
        }

        if (!response.ok)
            throw new Error('bad request');

        if (quotation.overlappingPolicy === 'true') {
            ui.state.slide = [1, 2];
            ui.notyf.error(`Exista deja o polita activa pana la ${moment(quotation.sixMonthQuotation.existingPolicyEndDate).format('DD/MM/YYYY')}`);
            insured.txtDate.state.date = moment(quotation.sixMonthQuotation.existingPolicyEndDate).add(1, 'day');
            insured.txtDate.state.focused = true;
            return;
        }

        state.quotations.custom = quotation;
    } catch (err) {
        ui.state.isLoading = false;
        ui.notyf.error('Ne pare rău, am întâmpinat o eroare');
        DOM.btnOffer12M.click();
        console.error(err);
    }
};

export const saveFile = (bytesBase64, mimeType, fileName) => {
  const source = `data:${mimeType};base64,${bytesBase64}`;
  const link = window.document.createElement('a');
  link.href = source;
  link.download = fileName;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const calc = (validity, hasDD, installments) => {
    let quote;
    switch (validity) {
        case 6:
            quote = state.quotations[6];
            break;
        case 12:
            quote = state.quotations[12];
            break;
        default://custom
            quote = state.quotations.custom;
            break;
    }
    if (!quote)
        return;

    state.id = quote.id;
    state.price = hasDD ? parseFloat(quote.premiumCommercial) + parseFloat(quote.directcompensationpremium) : parseFloat(quote.premiumCommercial);
    state.DDPrice = parseFloat(quote.directcompensationpremium);
    state.FIPrice = state.price;
    if (installments !== 1) {
        let ratePrice = Math.floor(state.price / installments);
        let diff = state.price - (ratePrice * installments);
        state.FIPrice = ratePrice + diff;
    }
    state.bonusMalus = quote.bonusMalus;
};

//controls
let customValidityPicker = (AttachState({
    showPopup: false,
    validity: 12
}, (state, DOM, refs) => {
    const btnTrigger = DOM.querySelector('.trigger-rates');
    const btnClose = DOM.querySelector('.close-tooltip-button');
    const btns = DOM.querySelectorAll('li>span');

    btnTrigger.addEventListener('click', () => {
        state.showPopup = !state.showPopup;
    });
    btnClose.addEventListener('click', () => {
        state.showPopup = false;
    });
    btns.forEach(btn => {
        btn.addEventListener('click', e => {
            state.validity = parseInt(e.target.innerHTML);
            refs.onSelect(state.validity);
            state.showPopup = false;
        });
    });

    state.bind('showPopup', value => {
        DOM.classList[value ? 'add' : 'remove']('view-rates');
    });
    state.bind('validity', value => {
        btns.forEach(btn => {
            btn.classList[parseInt(btn.innerHTML) === value ? 'add' : 'remove']('active');
        });
    });
}))(DOM.divOfferValidity, {
    onSelect: async value => {
        if ([6, 12].indexOf(value) === -1)
            await fetchQuotation(value);

        if (value === 6)
            return DOM.btnOffer6M.click();
        if (value === 12)
            return DOM.btnOffer12M.click();

        state.validity = value;
    }
});
// let customInstallmentsPicker = (AttachState({
//     showPopup: false,
//     installments: 1
// }, (state, DOM, refs) => {
//     const btnTrigger = DOM.querySelector('.trigger-rates');
//     const btnClose = DOM.querySelector('.close-tooltip-button');
//     const btns = DOM.querySelectorAll('li>span');

//     btnTrigger.addEventListener('click', () => {
//         state.showPopup = !state.showPopup;
//     });
//     btnClose.addEventListener('click', () => {
//         state.showPopup = false;
//     });
//     btns.forEach(btn => {
//         btn.addEventListener('click', e => {
//             state.installments = parseInt(e.target.innerHTML);
//             refs.onSelect(state.installments);
//             state.showPopup = false;
//         });
//     });

//     state.bind('showPopup', value => {
//         DOM.classList[value ? 'add' : 'remove']('view-rates');
//     });
//     state.bind('installments', value => {
//         btns.forEach(btn => {
//             btn.classList[parseInt(btn.innerHTML) === value ? 'add' : 'remove']('active');
//         });
//     });
// }))(DOM.divOfferInstallments, {
//     onSelect: value => {
//         state.installments = value;
//     }
// });
let DDPicker = (AttachState({
    hasDD: false
}, (state, DOM, refs) => {
    const btnYes = DOM.querySelectorAll('input')[1];
    const btnNo = DOM.querySelectorAll('input')[0];

    state.bind('hasDD', value => {
        if (value) {
            btnYes.checked = true;
            btnNo.checked = false;
        } else {
            btnYes.checked = false;
            btnNo.checked = true;
        }
    });

    btnYes.addEventListener('click', () => {
        refs.onSelect(true);
    });
    btnNo.addEventListener('click', () => {
        refs.onSelect(false);
    });
}))(DOM.divOfferDD, {
    onSelect: value => {
        state.hasDD = value;
    }
});
useKeys(DOM.btnOfferNext);
useKeys(DOM.btnOfferBack);

//bindings
state.bind('validity', value => {
    DOM.lblOfferValidity.innerText = `Valabilitate ${value} luni`;
    if (value === 1)
        DOM.lblOfferValidity.innerText = 'Valabilitate o lună';
});
state.bind('validity', value => {
    calc(value, state.hasDD, state.installments);
});
state.bind('installments', value => {
    DOM.lblOfferFIPrice.style.display = value === 1 ? 'none' : '';
    DOM.lblOfferFIPriceMobile.style.display = value === 1 ? 'none' : '';

    let text = 'Plata integrală';
    switch (value) {
        case 2:
            text = 'Plata în două rate';
            break;
        case 4:
            text = 'Plata în patru rate';
            break;
        case 12:
            text = 'Plata în douăsprezece rate';
            break;
    }
    DOM.lblOfferInstallments.innerText = text;
});
state.bind('installments', value => {
    calc(state.validity, state.hasDD, value);
});
state.bind('hasDD', value => {
    DOM.lblOfferDD.classList[value ? 'add' : 'remove']('active');
    DOM.lblOfferDDPrice.style.display = value ? '' : 'none';
    DOM.lblOfferDDPriceMobile.style.display = value ? '' : 'none';
    DDPicker.state.hasDD = value;
});
state.bind('hasDD', value => {
    calc(state.validity, value, state.installments);
});
state.bind('price', value => {
    DOM.lblOfferPrice.innerHTML = `${value.toLocaleString()} <span>lei</span>`;
    DOM.lblOfferPriceMobile.innerHTML = `${value.toLocaleString()} <span>lei</span>`;
});
state.bind('DDPrice', value => {
    DOM.lblOfferDDPrice.innerHTML = `Din care decontare directă: <strong>${value.toLocaleString()} lei</strong>`;
    DOM.lblOfferDDPriceMobile.innerHTML = `Din care decontare directă: <strong>${value.toLocaleString()} lei</strong>`;
});
state.bind('FIPrice', value => {
    DOM.lblOfferFIPrice.innerHTML = `Prima rată: <strong>${value.toLocaleString()} lei</strong>`;
    DOM.lblOfferFIPriceMobile.innerHTML = `Prima rată: <strong>${value.toLocaleString()} lei</strong>`;
});
state.bind('bonusMalus', value => {
    DOM.lblOfferBonusMalus.innerText = `Clasa de Bonus Malus. ${value}`;
});
state.bind('showPromoCar', v => {
    DOM.promoTextCar.style.display = v ? 'block' : 'none';
});
//events
DOM.btnDownloadOffer.addEventListener('click', async () => {
    ui.state.loaderText = 'Te rugăm să aștepți...';
    ui.state.isLoading = true;
    try {
        let id = state.id;
        if (state.hasDD || state.installments > 1) {
            let req = {
                vin: vehicle.state.vin,
                postalCode: insured.state.postalCode,
                county: insured.state.county,
                city: insured.state.cityCode,
                street: insured.state.street,
                startDate: insured.state.date.format('YYYY-MM-DD'),
                isRegistered: true,
                isLeasing: false,
                isTaxi: vehicle.state.isTaxi,
                vehicleClass: vehicle.state.class,
                vehicleBrand: vehicle.state.brand,
                vehicleType: vehicle.state.model,
                vehicleMaxWeight: vehicle.state.maxWeight,
                vehicleYear: vehicle.state.year,
                vehicleSeatNo: vehicle.state.seatNo,
                vehicleEnginePower: vehicle.state.enginePower,
                vehicleEngineDisplacement: vehicle.state.engineDisplacement,
                vehicleEnergySource: vehicle.state.energySource,
                insuranceInstalmentNo: state.installments,
                insurancePeriodInMonths: state.validity,
                isDirectCompensation: state.hasDD
            };
            if (insured.state.isCompany)
                req.cui = insured.state.cnp;
            else
                req.cnp = insured.state.cnp;
            
            let quotationResponse = await fetch(`${process.env.API_URL}/api/rcapolicy/quotation/web?requestId=${ui.state.flowId}`, {
                method: 'POST',
                body: JSON.stringify(req),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            // await new Promise(resolve => setTimeout(resolve, 1000));
            // let quotationResponse = {
            //     ok: true,
            //     json: async () => (singleQuotationMock)
            // };

            let quotation = await quotationResponse.json();
            if (quotation.body && !response.ok) {
                let faultstring = quotation.body.match(new RegExp('(<faultstring.+">)(.+(?=</faultstring))', 'im'));
                if (faultstring && faultstring.length > 0) {
                    faultstring = faultstring[faultstring.length - 1];

                    ui.state.isLoading = false;
                    ui.notyf.error(faultstring);
                    return;
                }
            }
            if (!quotationResponse.ok)
                throw new Error('bad request');

            id = quotation.id;
        }

        let response = await fetch(`${process.env.API_URL}/api/rcapolicy/offer/${id}/print?requestId=${ui.state.flowId}`, {});

        ui.state.isLoading = false;
        let print = await response.json();

        if (!response.ok)
            throw new Error('bad request');

        saveFile(print.bytes, 'octet/stream', print.filename);
    } catch (err) {
        ui.state.isLoading = false;
        ui.notyf.error('Ne pare rău, am întâmpinat o eroare');
        console.error(err);
    }
});
DOM.btnOfferBack.addEventListener('click', () => {
    ui.state.slide = [1, 2];
});
DOM.btnOffer6M.addEventListener('click', () => {
    state.validity = 6;
    state.installments = 1;

    //customInstallmentsPicker.state.showPopup = false;
    customValidityPicker.state.showPopup = false;

    DOM.btnOfferCustomM.classList.remove('active');
    DOM.divWrapper.classList.remove('view-pers-rates');
    DOM.divWrapper.classList.remove('view-bank-rates');
    DOM.btnOffer6M.classList.add('active');
    DOM.btnOffer12M.classList.remove('active');
});
DOM.btnOffer12M.addEventListener('click', () => {
    state.validity = 12;
    state.installments = 1 //customInstallmentsPicker.state.installments;

    //customInstallmentsPicker.state.showPopup = false;
    customValidityPicker.state.showPopup = false;

    DOM.btnOfferCustomM.classList.remove('active');
    DOM.divWrapper.classList.remove('view-pers-rates');
    DOM.divWrapper.classList.add('view-bank-rates');
    DOM.btnOffer6M.classList.remove('active');
    DOM.btnOffer12M.classList.add('active');
});
DOM.btnOfferCustomM.addEventListener('click', async () => {
    state.validity = customValidityPicker.state.validity;
    state.installments = 1;

    DOM.btnOfferCustomM.classList.add('active');
    DOM.divWrapper.classList.add('view-pers-rates');
    DOM.divWrapper.classList.remove('view-bank-rates');
    DOM.btnOffer6M.classList.remove('active');
    DOM.btnOffer12M.classList.remove('active');

    //customInstallmentsPicker.state.showPopup = false;
    customValidityPicker.state.showPopup = false;
});
DOM.btnOfferNext.addEventListener('click', () => {
    ui.state.slide = [3, 0];
    details.init();
});

module.exports.state = state;
module.exports.DOM = DOM;